import {AsyncStatus, usePaymentsState} from '@yandex-taxi/react-integration-api'
import React, {useMemo} from 'react'

import {isPaymentMethod} from '../../utils'
import AddPaymentButton from './AddPaymentButton'

type Props = {
  children: () => React.ReactElement
}

const CheckPayment: React.FC<Props> = ({children}) => {
  const {data, status} = usePaymentsState()
  const methods = data?.methods
  const payments = useMemo(() => methods?.filter(isPaymentMethod), [methods])

  if (payments && payments.length > 0) {
    return children()
  }

  const loading = status === AsyncStatus.PENDING
  const disabled = loading || status === AsyncStatus.INITIAL

  return <AddPaymentButton disabled={disabled} loading={loading} />
}
export default CheckPayment
